import { Link } from 'react-router-dom';
import { useTranslation } from '../../../utils/useTranslation';
import { IconNewTab } from '../../icon/IconNewTab';
import { Button } from '../../input/Button';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { Wrapper } from './styles';
import { AdvertisingShopCardProps } from './types';

export const AdvertisingShopCard: React.FC<AdvertisingShopCardProps> = ({
    name,
    description,
    badges,
    icon,
    url,
    ...other
}) => {
    const t = useTranslation();

    return (
        <Wrapper {...other}>
            <Flex direction="row" alignItems="center" width="100%" spacing={1} pt={0.5}>
                <Flex
                    width="32px"
                    height="32px"
                    background={`url(${icon})`}
                    backgroundSize="cover"
                    borderRadius="100%"
                    flexShrink={0}
                />
                <Typography variant="body" weight="bold" overflow="hidden" textOverflow="ellipsis">
                    {name}
                </Typography>
            </Flex>
            <Typography variant="caption" lines={4} my={1.5}>
                {description}
            </Typography>
            <Flex width="100%" mt="auto">
                {badges?.length ? (
                    <Flex direction="row" spacing={0.5} flexWrap="wrap" pb={1}>
                        {badges.map((badge) => (
                            <Typography
                                variant="caption2"
                                weight="medium"
                                px={0.75}
                                py={0.5}
                                background="var(--control-primary-color)"
                                borderRadius="100px"
                            >
                                {badge.text}
                            </Typography>
                        ))}
                    </Flex>
                ) : null}
                <Button
                    size="m"
                    color="secondary"
                    width="100%"
                    target="_blank"
                    as={Link}
                    to={`//${url}`}
                >
                    <Flex direction="row" alignItems="center" spacing={0.5}>
                        <Typography variant="caption" weight="bold">
                            {t('Перейти')}
                        </Typography>
                        <IconNewTab size="16px" color="var(--color-primary)" />
                    </Flex>
                </Button>
            </Flex>
        </Wrapper>
    );
};
